import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { ChangeDeliveryDatePayload } from './types/companies'

type ApiGetCompanyScheduleResponse = Promise<AxiosResponse<ChangeDeliveryDatePayload>>

export function getCompanySchedule(companyId: number): ApiGetCompanyScheduleResponse {
    const params = { companyId }

    return http.get('/cabinet/api/companies/schedule', { params })
}

export default {
    getCompanySchedule,
}
